export const useExportCsv = () => {
  const exportCsv = (url: string) => {
    const link = document.createElement('a')
    link.href = url
    link.click()
    link?.parentNode?.removeChild(link)
  }

  return { exportCsv }
}
